import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvCastList.html?raw';
import on from 'dojo/on';
import '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';

import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import PageStack from '../../../moreCore/UI/Tabbing/PageStack';
import "../../../moreCore/UI/Tabbing/PageStack";
import RadioGroup from '../../../moreCore/UI/RadioGroup/RadioGroup';
import "../../../moreCore/UI/RadioGroup/RadioGroup";
import { TranslationHelpers } from "../../../more/Helpers";
import EvCastEditor from '../../EvCast/EvCastEditor';


interface RedEntry extends VAM2types.EvCast {
    state: string,
    is_red_entry: boolean,
}

class EvCastList extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
	templateString: any = template;
    protected performerInput: MdsLax<InstanceType<typeof HintBox>>;
    protected castRedInput_Name: MdsLax<InstanceType<typeof Edit>>;
    protected castRedInput_Role: MdsLax<InstanceType<typeof Edit>>;

    protected sectionAddEntry: HTMLElement;
    protected syncInfoMessage: HTMLElement;
    protected addEntryPagestack: MdsLax<InstanceType<typeof PageStack>>;
    //redEntryInputContainer: HTMLElement;
    protected addRedEntryButton: HTMLButtonElement;

    protected redEntry: RedEntry;

    protected showSyncOption: boolean = false;
    protected inputSyncMode: MdsLax<InstanceType<typeof RadioGroup>>;
    protected syncModeContainer: HTMLElement;



    protected tableContainer: HTMLElement;
    protected table: MdsLax<InstanceType<typeof StaticTable>>;
    protected store: MdsLax<InstanceType<typeof EntityStore<VAM2types.EvCast>>>;
    protected evBookingId: string;
    protected entitylist: Array<any>;

    protected castTableLayout: StaticTable.RowConfig = {
        colNamesInternal: ["c_cast_address", "c_cast_perfomer"],
        "attributes": ["c_cast_address", "c_cast_perfomer"],
        "colspans": [1, 1],
        "headings": ["BookingEditor__castAddressTableHeader", "General_Label_Profession"],
        widths: [null, null/*, "15ch"*/],
        alignmentsHeading: [null, null/*, "right"*/],
        alignmentsRow: [null, null/*, "right"*/]
    };

    protected castTableLayoutStatus: StaticTable.RowConfig = {
        colNamesInternal: ["c_cast_address", "c_cast_perfomer", "ref_ev_cast_status.description"],
        "attributes": ["c_cast_address", "c_cast_perfomer", "ref_ev_cast_status.description"],
        "colspans": [1, 1, 1],
        "headings": ["BookingEditor__castAddressTableHeader", "General_Label_Profession", "General_Label_Status"],
        widths: [null, null/*, "15ch"*/],
        alignmentsHeading: [null, null/*, "right"*/],
        alignmentsRow: [null, null/*, "right"*/],
        bgColors: [null, null, "ref_ev_cast_status.coloration"]
    };

    protected table_formatterFunction(cell: StaticTable.StaticTableCell<VAM2types.EvCast>): boolean {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        this.UiModder.domClass.toggle(node, "w3-text-red", !entity.ref_performer);

        return false;
    }
    protected _onChange_StoreData() {

        if (!this.table) {
            this.setupTable();
        }

        //console.debug(this.id + ": _onChange_StoreData in EntityStore", diffData);
        if (this.store.isDirty()) {
            this._delayEmit();
        }
    }

    protected _emitHandle: any = null;
    protected _delayEmit() {
        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }


        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", this.getData()), 20);

    }

    protected _onChangePerformerInput(): void {
        let value = this.performerInput.getValue() as VAM2types.Performer;

        if (value != null) {
            let fakeCast: Partial<VAM2types.EvCast> = {
                ID: (Math.random() * 100000).toString(),
                c_cast_address: value.ref_address.gDisp_1,
                c_cast_perfomer: value.ref_ev_profession.description,
                ref_performer: value,
                $Displayname: `${value.gDisp_1}`
            }

            this.store.addEntry(fakeCast as any);

            this.performerInput.setValue(null, true);
        }
    }

    getData(): { entitylist: Array<VAM2types.EvCast>, syncMode: VAM2types.EvBookingSyncMode } {
        return {
            entitylist: this.store.getCurrentCompleteList(),
            syncMode: this.showSyncOption ?  parseInt(this.inputSyncMode.getValue() as string) as VAM2types.EvBookingSyncMode : null
        };
    }
    getDiffData() {
        let diffData = this.store.getDiffData(true);
        return diffData;
    }

    protected setupTable(): void {

        this.tableContainer.innerHTML = null;
        let bEdit = this.hasUserRole("EvCast_Edit");
        let bDelete = this.hasUserRole("EvCast_Delete");

        if (this.showSyncOption == true && this.inputSyncMode.getValue() == VAM2types.EvBookingSyncMode.synced) {
            bEdit = false;
            bDelete = false;
        }

        this.table = new StaticTable();

        if (bEdit) this.table.setupRowSorting("order");//, lang.hitch(this, this._onRowSorting));
        this.table.setFormatter(lang.hitch(this, this.table_formatterFunction));

        if (bDelete) this.table.addDefaultRowActionButton("delete");//, lang.hitch(this, this._onRowDeleting));
        //this.table.setHeadingLabelFormatter(this.table_formatterFunction__headingLabel);

        if (this.hasFeature("Planning/EvCastStatus")) this.table.addLineConfig(this.castTableLayoutStatus);
        else this.table.addLineConfig(this.castTableLayout);

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        if (bEdit) this.table.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditCast));

        //this.table.setData(this.entitylist);
        this.table.setupFromStore(this.store);
        this.table.setCyAttribute("evCastList");
    } 

    protected _onClickEditCast(row: StaticTable.StaticTableRowGroup<VAM2types.EvCast>) {
        let editor = new EvCastEditor();
        editor.setup(row.entity);

        editor.on("confirmed", lang.hitch(this, this._onConfirmedCastEditor))
    }

    protected _onConfirmedCastEditor(data: VAM2types.EvCast) {
        this.store.changeEntry(data, true);
    }

    protected _onClick_OpenEvCastSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvCast_EvBooking",
            lang.hitch(this, this._onCallback_Dlg),
            null,
            { bookingID: this.evBookingId }
        );
    }

    protected _onCallback_Dlg(mode: string, data, items) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet
        if (!items || !items.length) return;

        for (let item of items) {
            let entity = {
                ID: item.entry.value, gDisp_1: item.entry.label, $Displayname: item.entry.label
            }

            if (mode == "selectEvCast_EvBooking") {
                this.performerInput.setValue(item.entry.data);
            }
        }

        //this.previousSEDvalue = items;
    }



    protected _onChangeRedInput(value: any): void {

        if (value != null) this.redEntry = {
            $Displayname: "",
            ID: null,
            Classname: VAMclassNames.ev_cast,
            is_red_entry: true,
            order: null,
            state: "new",
            c_cast_address: this.castRedInput_Name.getValue(),
            c_cast_perfomer: this.castRedInput_Role.getValue(),
            ref_performer: null
        };

        let readyCheck = this.castRedInput_Name.getValue() ||
            this.castRedInput_Role.getValue();
        //this.opusRedInput_Author.getValue() ||
        //this.opusRedInput_Duration.getValue() != null;

        this.UiModder.domClass.toggle(this.addRedEntryButton, "w3-disabled", !readyCheck);
    }


    protected _onClickAddRedEntryButton(): void {

        let fakeCast: Partial<VAM2types.EvCast> = {
            ID: (Math.random() * 100000).toString(),
            ref_performer: null,
            c_cast_address: this.redEntry.c_cast_address,
            c_cast_perfomer: this.redEntry.c_cast_perfomer
        }

        //this.store.reset();

        this.store.addEntry(fakeCast as any);

        this.performerInput.setValue(null, true);
        this.castRedInput_Name.setValue(null, true);
        this.castRedInput_Role.setValue(null, true);

    }

    protected _onChange_SyncMode(value) {
        if (this.showSyncOption) {
            this._delayEmit();
        }
        this.store.rollback();
        this._handleSyncModeDisplayStyle();

        this.setupTable();
        
    }

    protected _handleSyncModeDisplayStyle() {
        let mode: VAM2types.EvBookingSyncMode = this.inputSyncMode.getValue();

        this.inputSyncMode.setReadonly(!this.hasUserRole("EvCast_Edit"));

        this.hideNode(this.syncModeContainer, !this.showSyncOption);
        this.hideNode(this.syncInfoMessage, !this.showSyncOption);

        this.hideNode(this.addEntryPagestack, mode == VAM2types.EvBookingSyncMode.synced);
        this.UiModder.domAttr.set(this.syncInfoMessage, "innerHTML", TranslationHelpers.translate(mode == VAM2types.EvBookingSyncMode.individual ? "EvCast_InfoText__SyncModeIndividual" : "EvProgram_InfoText__SyncedFromEvProject"))
        
    }

    setup(data: Array<VAM2types.EvCast>, evBookingId: string, syncMode?: VAM2types.EvBookingSyncMode) {
        this.store.setup(data, "ID");
        this.evBookingId = evBookingId;
        this.entitylist = data;

        if (typeof (syncMode) != "undefined") {
            this.inputSyncMode.setValue(syncMode, true);
            // change beim Setup einmal unterdrücken und sich selber um den Style kümmern:
            this._handleSyncModeDisplayStyle();
        }


        this.setupTable();
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));

        this.hideNode(this.sectionAddEntry, !this.hasUserRole("EvCast_Create"));

        if (this.hasFeature("EvCast/disableCatalogSelection")) {
            this.addEntryPagestack.hidePage("select");
        }
        if (this.hasFeature("EvCast/disableRedEntries")) {
            this.addEntryPagestack.hidePage("redEntry");
        }

        this.showSyncOption = this.hasFeature("EvProject/EvCast");
        this._handleSyncModeDisplayStyle();

        if (this.showSyncOption) {            
            on(this.inputSyncMode, "change", lang.hitch(this, this._onChange_SyncMode));
        }


        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";

        this.performerInput.addInlineButton(lang.hitch(this, this._onClick_OpenEvCastSED));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvCastList);